import ApplicationController from '../application_controller';

export default class extends ApplicationController {
  connect() {
    const descuentoSelect = this.element.querySelector('[name*="descuento_id"]');
    const nombreInput = this.element.querySelector('[name*="nombre"]');
    const cuentaContableSelect = this.element.querySelector('[name*="cuenta_contable_id"]');
    const cuentaContableContainer = cuentaContableSelect?.closest('.row');

    if (descuentoSelect && nombreInput) {
      descuentoSelect.addEventListener('change', () => {
        const selectedOption = descuentoSelect.options[descuentoSelect.selectedIndex];
        const isManual = !selectedOption.value;

        if (selectedOption.value) {
          nombreInput.value = selectedOption.text;
        } else {
          nombreInput.value = '';
        }

        if (cuentaContableSelect && cuentaContableContainer) {
          if (isManual) {
            cuentaContableContainer.style.display = '';
          } else {
            cuentaContableContainer.style.display = 'none';
            cuentaContableSelect.value = '';
          }
        }

        nombreInput.focus();
      });

      if (cuentaContableSelect && cuentaContableContainer) {
        const isManual = !descuentoSelect.value;
        cuentaContableContainer.style.display = isManual ? '' : 'none';
      }
    }
  }
}
